var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('authentication-wrapper',[_c('router-view',{attrs:{"email":_vm.email},on:{"update:email":function($event){_vm.email=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }